import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TourContentRegistryService {
  private currentTourContentService$ = new BehaviorSubject<any>(null);

  /**
   * Observable that emits whenever tour service registration changes
   */
  public tourService$: Observable<any> = this.currentTourContentService$.asObservable();

  /**
   * Register a tour content service (called by route components)
   */
  register(service: any): void {
    console.log('[TourRegistry] Registering tour service:', !!service);
    this.currentTourContentService$.next(service);
  }

  /**
   * Unregister the tour content service (called when route component destroys)
   */
  unregister(): void {
    console.log('[TourRegistry] Unregistering tour service');
    this.currentTourContentService$.next(null);
  }

  /**
   * Get the currently registered tour content service
   */
  get(): any {
    return this.currentTourContentService$.value;
  }

  /**
   * Check if a tour service is available
   */
  isAvailable(): boolean {
    return !!this.currentTourContentService$.value;
  }
}

